import request, { ResponsePageableData } from '@/libs/requestTwo'

/** 订单退款 */
export const refundOrder = (data?) => request<ResponsePageableData>({ url: '/adminapi/OrderHotel/refundOrder', data })
